import { replace } from 'connected-react-router';
import { all, fork, put, putResolve, select, take } from 'redux-saga/effects';
import { REHYDRATE } from 'redux-persist';
import qs from 'query-string';

import { selectServiceConfig, selectCountry, selectSearchObj, selectLanguage, selectClient, selectOneTimeToken } from '../../global-selectors';
// import { selectLoginUrl } from '../../queries/selectors/user';

import { requestAsync } from '../../queries/actions';
import { bootstrapAppRequest } from '../../queries/bootstrap';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { get } from '../../utils/lodash';
// import { statusRequest } from '../cloudPass';
import { getTransactionByOrderId } from '../transactions';
import { BOOTSTRAP_LOADING, BOOTSTRAP_LOADED } from '../actions/constants';

export function decodeJWT(token) {
  const [, claims] = (token && token.split('.')) || [];
  return claims && JSON.parse(atob(claims));
}

export function* watchRehydrateOrLoginSaga() {
  while (true) {
    // integrate with   login as well once implemented
    yield take([REHYDRATE /* , LOGIN_SUCCESS */]);
    if (!window.location.pathname.includes('/motorplay/error/')) {
      yield put({ type: BOOTSTRAP_LOADING });
    }
    const serviceConfig = yield select(selectServiceConfig);
    const queryCountry = yield select(selectCountry);
    const language = yield select(selectLanguage);
    const client = yield select(selectClient);
    const methodId = yield select(selectCurrentPaymentMethod);
    // const loginUrl = yield select(selectLoginUrl);
    // const cp = yield select(selectContentProvider);
    const oneTimeToken = yield select(selectOneTimeToken);
    const country = queryCountry || serviceConfig.country;
    const { orderId, promoSlug, couponCode, ...searchObj } = yield select(selectSearchObj);

    const auth = {
      country,
      client,
    };

    if (oneTimeToken) {
      auth.one_time_token = oneTimeToken;
      localStorage.removeItem('jwt');
      delete auth.jwt_token;
    } else if (localStorage.getItem('jwt')) {
      
      auth.jwt_token = localStorage.getItem('jwt');
      
    } /* else {
        const params = {
          cp: cp,
          client: client,
          country_code: queryCountry,
          // TODO: FIND OUT WICH ONE SHOULD BE USED
          return_url: 'https://dummy-cert.tbxnet.com/'
        }
        const loginUrlReplaced = replaceParamsLoginUrl(loginUrl, params);
        window.location.replace(loginUrlReplaced);
      } */
     
    if (!window.location.pathname.includes('/motorplay/error/')) {
      const bootstrap = yield putResolve(requestAsync(bootstrapAppRequest, {
        body: {
          ...auth,
          ...(couponCode && { couponCode: couponCode?.toUpperCase() }),
          ...(promoSlug && { promoSlug })
        }
      }));

      if (bootstrap.status === 200) {
        localStorage.setItem('jwt', bootstrap.entities && bootstrap.entities.user.token);
        delete auth.one_time_token;
      }

      if (bootstrap.status >= 400) {
        const { code, error } = bootstrap.body || {};
        // Catch unsupported regions
        if (code === 'CPAY-030') {
          yield put(
            replace({
              pathname: `/${client}/error/region`,
              search: {
                ...searchObj,
                language,
                country,
              },
            })
          );

          yield put({ type: BOOTSTRAP_LOADED });
          return;
        }

        const serialized = btoa(JSON.stringify(error));
        yield put(
          replace({
            pathname: `/${client}/error/${code}/${serialized}`,
            search: {
              ...searchObj,
              language,
              country,
            },
          })
        );

        return yield put({ type: BOOTSTRAP_LOADED });
      }

      if (orderId) {
        const transaction = yield putResolve(
          requestAsync(getTransactionByOrderId, {
            orderId,
          })
        );

        if (bootstrap.status !== 200) {
          return yield put({ type: BOOTSTRAP_LOADING });
        }

        const serializedSearch = qs.stringify(searchObj);
        const transactionType = get(transaction, 'body.transactionType');
        const transactionStatus = get(transaction, 'body.data.status');

        if (transactionType === 'SUBSCRIPTION') {
          switch (transactionStatus) {
            case 'SUCCESSFUL':
              yield put(
                replace({
                  search: serializedSearch,
                  state: {
                    showSubscriptionCompletedModal: true,
                  },
                })
              );
              break;
            case 'DECLINED':
            case 'FAILED':
            case 'ERROR':
              yield put(
                replace({
                  search: serializedSearch,
                  state: {
                    showSubscriptionRejectedModal: true,
                    productID: transaction.body.data.productID,
                  },
                })
              );
              break;
            default:
              yield put(
                replace({
                  search: serializedSearch,
                })
              );
              break;
          }
        }
      }
    }

    yield put({ type: BOOTSTRAP_LOADED });
  }
}

export function* mainSaga() {
  yield all([fork(watchRehydrateOrLoginSaga)]);
}

export default mainSaga;
